import { gql } from "lib/apolloClient";
import {
  courseFragment,
  curriculumProgramFragment,
} from "modules/CommonFragments";

export const getSourceSubjectsOfSubjectGroupQuery = gql`
  query getSourceSubjectsOfSubjectGroup($subjectGroupId: ID!) {
    node(id: $subjectGroupId, type: SUBJECT_GROUP) {
      ... on SubjectGroup {
        id
        sourceSubjects {
          id
          name
        }
      }
    }
  }
`;

export const getOrganizationSubjectGroupsQuery = gql`
  query getOrganizationSubjectGroups(
    $id: ID!
    $filters: SubjectGroupFilterInput
    $subjectFilters: SubjectFilterInput
    $subjectCourseFilter: SubjectCourseFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjectGroups(filters: $filters) {
          id
          name
          globalSubjectGroup {
            id
            constants
          }
          subjects(filters: $subjectFilters) {
            id
            name
            icon
            iconType
            grades {
              id
              name
            }
            courses(filters: $subjectCourseFilter) {
              edges {
                node {
                  ...courseGradeItem
                }
              }
              totalCount
            }
            unitPlans {
              totalCount
            }
            isArchived
          }
          curriculumProgram {
            ...curriculumProgramBasicDetailsItem
          }
          sourceSubjects {
            id
            name
          }
        }
      }
    }
  }
  ${courseFragment.courserGradesDetails}
  ${curriculumProgramFragment.curriculumProgramBasicDetails},
`;
